import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import ReactGA from 'react-ga'
import Home2 from './Home2'
import HeroCanvas from '../HeroCanvas'
import Counter from '../Counter'
import Reveal from '../Reveal'
import InteractiveTerminal from './InteractiveTerminal'
import Type from './Type'
import Certifications from '../Certifications'
import TechMarquee from '../TechMarquee'
import Magnetic from '../Magnetic'
import ScrambleText from '../ScrambleText'
import { burstConfetti } from '../../utils'

function Home() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [])

  return (
    <section>
      <div className="home-section">
        <HeroCanvas />
        <div className="home-content">
          <div className="home-left hero-stagger">
            <div className="home-badge"><span className="pulse-dot" /> <Type /></div>
            <h1 className="home-title">
              Hi, I'm Amaan —<br />
              I turn ideas into{' '}
              <span className="home-title-accent">intelligent software.</span>
            </h1>
            <p className="home-subtitle">
              An AI ML Developer with hands-on experience delivering
              production-grade AI systems — spanning computer vision,
              LangChain-powered RAG chatbots, IoT automation, and
              scalable deployments on AWS &amp; GCP.
            </p>
            <div className="home-cta-group">
              <Magnetic>
                <Link to="/project" className="btn-filled">
                  See my work →
                </Link>
              </Magnetic>
              <Magnetic>
                <a href="https://www.linkedin.com/in/amaan-akbany5/" target="_blank" rel="noreferrer" className="btn-outline">
                  Get in touch
                </a>
              </Magnetic>
            </div>
          </div>

          <div className="home-right">
            <InteractiveTerminal />
          </div>
        </div>
        <div className="scroll-hint" aria-hidden="true"><span /></div>
      </div>
      <div className="stats-strip">
        <div className="section-inner stats-grid">
          {[
            { n: 3, s: '+', l: 'Production AI systems' },
            { n: 4, s: '', l: 'Projects shipped' },
            { n: 3, s: '', l: 'Certifications' },
            { n: 2, s: '', l: 'Cloud platforms' },
          ].map((x, i) => (
            <Reveal key={x.l} delay={i * 100} className="stat">
              <div className="stat-num"><Counter to={x.n} suffix={x.s} /></div>
              <div className="stat-label">{x.l}</div>
            </Reveal>
          ))}
        </div>
      </div>
      <TechMarquee />
      <Home2 />
      <Certifications />
      <div className="section contact-cta">
        <div className="section-inner">
          <Reveal className="contact-box">
            <div className="section-tag">contact</div>
            <h2 className="section-title"><ScrambleText text="Let's build something intelligent." /></h2>
            <p className="contact-sub">Open to AI/ML, computer vision and cloud engineering roles and collaborations.</p>
            <Magnetic>
              <a
                href="https://www.linkedin.com/in/amaan-akbany5/"
                target="_blank"
                rel="noreferrer"
                className="btn-filled"
                onClick={e => burstConfetti(e.clientX, e.clientY)}
              >
                Say hello 👋
              </a>
            </Magnetic>
            <p className="contact-hint">Tip: press <kbd>Ctrl/⌘ K</kbd> anywhere to jump around.</p>
          </Reveal>
        </div>
      </div>
    </section>
  )
}

export default Home
